import React, { useEffect } from 'react'
import Slider from 'react-slick'
import CarouselDots from './dots'
import CarouselArrows from './arrows'
import useCarousel from '@src/hooks/useCarousel';
import { useIsMobile } from '@utils/general';
import ButtonGroup from '../button-group';

const Carousel = ({ heading, description, ctaList, settings, className, children }) => {
	const isMobile = useIsMobile();

	const { hoverAnimation, sliderRef, ignoreHiddenItems } = useCarousel();
	let scrollDelta = 0;

	const handleMouseWheel = (e) => {
		e.preventDefault();

		scrollDelta += e.deltaY;

		const scrollThreshold = 10;

		if (scrollDelta >= scrollThreshold) {
			sliderRef.current.slickPrev(); // Scroll backward
			scrollDelta = 0;
		} else if (scrollDelta <= -scrollThreshold) {
			sliderRef.current.slickNext(); // Scroll forward
			scrollDelta = 0;
		}
	};

	useEffect(() => {
		settings?.animateOnHover &&
			window.innerWidth > 768 &&
			settings?.numberOfSlides > 1 &&
			hoverAnimation();

		if (sliderSettings.mouseWheel) {
			sliderRef?.current?.innerSlider?.list.addEventListener('wheel', handleMouseWheel);
		}

		if (settings?.isBundleShowcaseSlider) {
			const bundleShowcaseListWidth = +sliderRef?.current?.innerSlider?.list?.offsetWidth;
			// sliderRef?.current?.innerSlider?.list.addEventListener('wheel', handleMouseWheel);
			document.documentElement.style.setProperty("--bundle-showcase-slider-size-1", +bundleShowcaseListWidth * 0.24609375 + "px");
			document.documentElement.style.setProperty("--bundle-showcase-slider-size-2", +bundleShowcaseListWidth * 0.3359375 + "px");
			document.documentElement.style.setProperty("--bundle-showcase-slider-size-3", +bundleShowcaseListWidth * 0.4203125 + "px");
		}

		return () => {
			if (sliderSettings.mouseWheel) {
				sliderRef?.current?.innerSlider?.list.removeEventListener('wheel', handleMouseWheel);
			}
		};
	}, []);

	const sliderSettings = {
		...settings,
		accessibility: true,
		touchThreshold: 10,
		animateOnHover: true,
		appendDots: (dots) => (<CarouselDots dots={dots} />),
		slidesToShow: settings?.slidesToShow?.desktop,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: settings?.slidesToShow?.mobile,
					variableWidth: false,
				}
			}
		],
		useTransform: !isMobile,
		afterChange: () => {
			settings?.animateOnHover &&
				!isMobile &&
				settings?.numberOfSlides > 1 &&
				hoverAnimation()
			
			if (sliderRef?.current) {
				ignoreHiddenItems(null, '.btn');
			}
		},
	};

  const interceptSwiped = (e) => {
    if(e.target.tagName === "IMG") {
      const imageContainer = e.target.parentNode.parentNode.parentNode
      imageContainer.classList.add("pointer-events-none");

      setTimeout(() => {
        imageContainer.classList.remove("pointer-events-none");
      }, 300)
    }
  };

	useEffect(() => {
		if (sliderRef?.current) {
			ignoreHiddenItems(null, '.btn, a');
		}
	}, [])

	return (
		<div 
			className="flex flex-col max-w-full w-full gap-y-5"
			onMouseMove={(e) => e.buttons === 1 && interceptSwiped(e)}
			aria-label='Slider'
			tabIndex={0}
		>
			{(heading || description || settings?.arrows) &&
				<div className="flex justify-between relative">
					{(heading || description) && <div className="section-intro" aria-label='Section Intro' tabIndex={0}>
						{heading && <h2 tabIndex={0}>{heading}</h2>}
						{description && <p tabIndex={0}>{description}</p>}
					</div>}
					{ctaList?.length > 0
						? <ButtonGroup isFullWidth={false} list={ctaList} className="max-md:hidden" />
						: settings?.arrows && <CarouselArrows sliderRef={sliderRef} />}
				</div>
			}
			<Slider ref={sliderRef} {...sliderSettings} className={`w-full slider ${className} ${sliderSettings?.variableWidth ? 'slider-variable-width' : ''}`}>
				{children}
			</Slider>
			{ctaList?.length > 0 && <ButtonGroup isFullWidth={false} list={ctaList} className="md:hidden" />}
		</div>
	)
}

export default Carousel